import React from 'react'
import fiserv from './fiservLogo.png'
import infinite from './infiniteLogo.png'
import volstory from './volstory.png'
import { useEffect } from 'react'
export default function WorkExperience(props){
    useEffect(()=>{
        props.setShowNavbar(true);
    })
    return(
        <div>
        <h1 style={{fontFamily:"Monsterrat",fontWeight:"bold",margin:"20px 0 50px 0",fontSize:"60px",color:"#1D3353"}}>Work Experience</h1>
        <div className="list-group" style={{margin:"10px 30px 20px 0px"}}>
            <div style={{display:"flex"}}>        
            <a href='https://www.infinite.com/'><img src={infinite} style={{height:"8vh",width:"8vh",margin:"0 20px 0 10px"}}/></a>
            <div className="list-group-item list-group-item-action" >
                <div className="d-flex w-100 justify-content-between">
                    <h5 className="mb-1" style={{fontWeight:"bolder"}}>Infinite Computer Solutions</h5>
                    <small>
                        December 2022 - June 2023
                    </small>
                </div>
                <p className="mb-1" style={{textAlign:"start",fontWeight:"bold"}}>Software Engineer</p>
                <p style={{textAlign:"start"}}><small>
                As a Software Engineer at Infinite Computer Solutions, I played a pivotal role in the software development of Defi Solutions, a widely used vehicle loan management system serving over 350 clients worldwide. 
                <br/>
During this tenure, major technologies that were used included ASP.NET, C#, MVC, Microsoft Azure, MySQL, Java, JavaScript, HTML, CSS, and Github.
<br/><br/>
I joined as a freshman at this organization, my initial 3 months were used for training. Since I excelled in training, I was immediately assigned to a project and started working upon the project that I mentioned above.
<br/><br/>
Overall, I as a Software Engineer at Infinite Computer Solutions demonstrated a deep commitment to software development, effective collaboration, and skill enhancement. My contributions were aligned with the success of Defi Solutions, and my ability to nurture essential skills and improve team communication made me a valuable asset to the organization.
<br/><br/>
My contributions went beyond coding, encompassing various aspects of teamwork, collaboration, and skill development.</small></p>
            </div>
            </div>
        </div>
        <div className="list-group"style={{margin:"10px 30px 20px 0px"}}>
        <div style={{display:"flex"}}>        
            <a href='https://www.fiserv.com/'><img src={fiserv} style={{height:"8vh", width:"8vh",margin:"0 20px 0 10px"}}/></a>
            <div className="list-group-item list-group-item-action" >
                <div className="d-flex w-100 justify-content-between">
                    <h5 className="mb-1" style={{fontWeight:"bolder"}}>Fiserv</h5>
                    <small>
                        August 2022 - November 2022
                    </small>
                </div>
                <p className="mb-1" style={{textAlign:"start",fontWeight:"bold"}}>Technology Program Analyst</p>
                <p style={{textAlign:"start"}}><small></small></p>
            </div>
            </div>
        </div>
        <div className="list-group" style={{margin:"10px 30px 20px 0px"}}>
        <div style={{display:"flex"}}>        
            <img src={volstory} style={{height:"8vh", width:"8vh",margin:"0 20px 0 10px"}}/>
            <div className="list-group-item list-group-item-action" >
                <div className="d-flex w-100 justify-content-between">
                    <h5 className="mb-1" style={{fontWeight:"bolder"}}>Volstory</h5>
                    <small>
                        March 2021 - June 2021
                    </small>
                </div>
                <p className="mb-1" style={{textAlign:"start",fontWeight:"bold"}}>Full Stack Developer</p>
                <p style={{textAlign:"start"}}><small>
                Managed a mobile application called Vrinda, an event management application enhancing cultural heritage and gives 
opportunities to artists and performers thus providing a platform to more than 1,000 artists in India.<br/><br/>

Developed a complete front-end starting from sketch to final prototype for a food ordering application using Flutter.
<br/><br/>

Major technologies that were used included Flutter, Dart, Firebase, Maven, Spring Boot, Java</small></p>
            </div>
            </div>
        </div>
        {/* <div style={{display:"flex",alignItems:"center"}}> 
                <div style={{padding:"30px 30px 30px 30px",height:"100vh",width:"60vw",border:"2px solid black"}}>
                    <p style={{margin:"50px 30px 0 0",wordWrap:"break-word",textAlign:"start"}}>FaceSham app provide the interface for the users to filter their media. Initial step will be user uploading the video throught the app. The video is stored in firebase database, also onces the video is uploaded a flask api request is made which then indiates the cloud processing unit/local computer for starting the deeplearning pipeline on the input video. The result of the deep learning model is then sent back to the FaceSham app. The following flowchart diagram explains the same.</p>
                    <br></br> 
                </div>
                <div style={{width:"40vw"}}>
                <h1 style={{fontFamily:"Monsterrat",fontWeight:"bold",textAlign:"start"}}>Stock Market Prediction Based on Twitter Sentiment Analysis</h1>
                    
                </div>
            </div> */}
   
    </div>
    )
}